module.exports = __webpack_public_path__ + "img/icon_exchange_coin.8dc4d94a.png";